import { ajaxRequest } from "../../Utils/Ajax/ajax";
import { changeUrl, errorToast, getSearchParam, infoToast, successToast } from "../../Utils/utils";


export class MessageInbox {
    holder:JQuery

    constructor() {
        this.holder = $(".email-app");
        this.addListeners();
        this.actIfMessageWantsToBeLoaded();
    }

    actIfMessageWantsToBeLoaded(){
        const messageId = getSearchParam('mid', false);
        if (messageId){
            const type = getSearchParam('type', false);
            if (type){
                this.loadMessage(messageId, type);
                $('.right-part.mail-list').fadeOut("fast");
                $('.right-part.mail-details').fadeIn("fast");
            }
        }
    }

    addListeners(){
        const self = this;
        this.holder.on("click", ".link", function(){
            const parent = $(this).parent().parent();
            const type = parent.attr('data-type');
            const messageId = parent.attr('data-id');
            self.loadMessage(messageId, type);
        });
        this.holder.on("click", ".accept-tutor-job", function(){
            const courseId = $(this).attr("data-fach");
            const hta = Number($(this).attr("data-hta"));
            if (hta == 1){
                self.loadTutorAgb(courseId);
            } else {
                self.acceptTutorJob(courseId, $(this));
            }
        });
        $(document).on("click", ".accept-tutor-job-and-agb", function(){
            const courseId = $(this).attr('data-course');
            const check = ($("#checkbox-tutor-agb").is(":checked"));
            if (check){
                self.acceptTutorJobPlusAgb(courseId, $(this));
            } else {
                errorToast("Bevor du Tutor/-in wirst, musst du die AGBs akzeptieren", "Fehler", 0);
            }
        });
    }

    loadTutorAgb(courseId){
        const content = `<div class="checkbox checkbox-primary mb-3">
                            <input id="checkbox-tutor-agb" type="checkbox" class="chk-col-indigo material-inputs check-field">
                            <label for="checkbox-tutor-agb"> Ich akzeptiere die <a href="../agb-tutor" target="_blank">erweiternden allgemeinen Geschäftsbedinungen</a>
                             für Tutor/-innen</label>
                        </div>`;
        const submitBtn = {
            class: "accept-tutor-job-and-agb",
            data: 'data-course="' + courseId + '"',
            text: 'Angebot Annehmen',
        }
        const modal = makeModal("tutor-agb-accept", "Tutor-Angebot annehmen", content, submitBtn, true, "");
        modal.show();
    }

    acceptTutorJob(courseId, btn){
        const self = this;
        const url = '/invitation/tutor/accept/' + courseId.toString()

        const data = {}

        const success = function(data){
            self.tutorSuccess(data);
        }

        return ajaxRequest(url, success, data, btn)
    }

    acceptTutorJobPlusAgb(courseId, btn){
        const self = this;
        const url = '/invitation/tutor/accept/' + courseId.toString()

        const data = {
            agb: true
        }

        const success = function(data){
            self.tutorSuccess(data);
        }

        return ajaxRequest(url, success, data, btn)
    }

    tutorSuccess(data){
        successToast("Du bist nun Tutor/-in", "Erfolg", 5500, true);
            setTimeout(function(){
               changeUrl('home');
        }, 1250)
    }

    loadMessage(messageId, type){

        const url = '/message/' + messageId.toString() + '/load'

        infoToast('Warte kurz', 'Nachricht lädt');

        const success = function (data){
            toastr.remove()
            $("#message-detail").html(data.html);
        }

        return ajaxRequest(url, success);

    }
}